import { key } from "./global/globals";
const getScriptSrc = ({
  enterprise,
  useRecaptchaNet,
  siteKey
}) => {
  const hostname = useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  if (enterprise) {
    return `https://${hostname}/recaptcha/enterprise.js?render=${siteKey}&onload=${key}`;
  }
  return `https://${hostname}/recaptcha/api.js?render=${siteKey}&onload=${key}`;
};
const maybeInjectScript = ({
  appendTo,
  ...scriptProps
}) => {
  const el = document.querySelector(`script[id=${scriptProps.id}]`) ?? document.createElement("script");
  Object.assign(el, scriptProps);
  (appendTo === "head" ? document.head : document.body).appendChild(el);
};
const maybeRemoveScript = (scriptId) => {
  const el = document.querySelector(`script[id=${scriptId}]`);
  if (el !== null) {
    document.head.removeChild(el);
  }
};
export {
  getScriptSrc,
  maybeInjectScript,
  maybeRemoveScript
};
